import React, { useEffect, useState, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './App.css'; 

const IntroScreen = ({ onFinish }) => {
  const [visible, setVisible] = useState(true);

  const handleFinish = useCallback(() => {
    setVisible(false);
    setTimeout(onFinish, 500); // Beri waktu untuk animasi fade-out
  }, [onFinish]);

  useEffect(() => {
    const timer = setTimeout(() => {
      handleFinish();
    }, 7000); // Intro akan hilang setelah 7 detik

    return () => clearTimeout(timer);
  }, [handleFinish]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="intro-overlay"
          onClick={handleFinish}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5 }}
        >
          <motion.div 
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            <img 
              src="https://i.pinimg.com/originals/00/63/8a/00638af37801f6760233d820d1fbd978.gif" 
              alt="Profil Kreator" 
              className="intro-gif" 
            />
          </motion.div>
          <motion.div 
            className="intro-text"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 1 }}
          >
            <h2>Wisnu Hidayat</h2>
            <p>Mahasiswa Teknik Informatika - UNISNU Jepara</p>
            <p className="intro-purpose">Dibuat untuk menyelesaikan tugas kuliah</p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default IntroScreen; 